<template>
  <span class="d-inline-flex align-center flex-wrap" style="gap: 6px">
    <v-btn small text color="error" :disabled="working" @click="rejection = { open: true, reason: '' }">{{ $t('onboarding.commissioning.decision.reject') }}</v-btn>
    <v-btn small color="success" :loading="working" @click="approve">{{ $t('onboarding.commissioning.decision.approve') }}</v-btn>

    <!-- Refuser s'explique toujours : le motif reste sur la commande, et la personne le lit. -->
    <v-dialog v-model="rejection.open" max-width="520">
      <v-card>
        <v-card-title class="text-h6">{{ $t('onboarding.queue.reject-title', { person: beneficiaryOf(order), kind: kindLabel(order.kind) }) }}</v-card-title>
        <v-card-text>
          <p class="text-caption">{{ $t('onboarding.commissioning.decision.reject-explained') }}</p>
          <v-textarea v-model="rejection.reason" :label="$t('onboarding.queue.reject-reason')" outlined auto-grow rows="2" autofocus />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small text @click="rejection.open = false">{{ $t('cancel') }}</v-btn>
          <v-btn small color="error" :disabled="!rejection.reason.trim()" :loading="working" @click="reject">{{ $t('onboarding.commissioning.decision.reject') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import CommissioningRepository from '@repository/CommissioningRepository'
import CommissioningMixin from '../CommissioningMixin'

/**
 * Valider ou refuser une commande : le même geste dans la file, le tiroir et la fiche. Valider se confirme quand on n'a
 * pas la commande sous les yeux (`confirm`) ; refuser demande toujours le motif. Rend la commande à jour (`updated`).
 */
export default {
  name: 'OrderApprovalActions',

  mixins: [CommissioningMixin],

  props: {
    order: { type: Object, required: true },
    confirm: { type: Boolean, default: false },
  },

  data() {
    return { working: false, rejection: { open: false, reason: '' } }
  },

  methods: {
    async approve() {
      if (this.confirm && !(await this.$dialog.confirm({
        title: this.$t('onboarding.queue.approve-title'),
        text: this.$t('onboarding.queue.approve-text', { person: this.beneficiaryOf(this.order), kind: this.kindLabel(this.order.kind), organization: this.order.organizationName || '' }),
      }))) return
      await this.decide('approve')
    },

    async reject() {
      if (await this.decide('reject', this.rejection.reason.trim())) this.rejection = { open: false, reason: '' }
    },

    async decide(decision, reason = '') {
      this.working = true
      try {
        this.$emit('updated', await CommissioningRepository.decide(this.order.id, decision, reason))
        return true
      } catch (e) {
        this.notifyError(e)
        return false
      } finally {
        this.working = false
      }
    },
  },
}
</script>
